import { DrawerClose } from '@/shadcn/ui/drawer'
import { ChevronsRight } from 'lucide-react'
import { DrawerDescription } from '@/shadcn/ui/drawer'
import { DrawerTitle } from '@/shadcn/ui/drawer'
import { DrawerHeader } from '@/shadcn/ui/drawer'
import { Typography } from '@/ui/atoms/typography/Typography'
import { Info } from '@/ui/molecules/info/Info'
import { ConnectButton } from '@/features/navbar/components/wallet-button/ConnectButton'

export function GuestView() {
  return (
    <>
      <DrawerHeader className="gap-0 text-left">
        <DrawerClose className="mt-4 transition-colors hover:text-primary">
          <ChevronsRight className="h-4 w-4" />
        </DrawerClose>

        <DrawerDescription className="mt-6 mb-1 pl-1">
          <span className="flex items-center gap-1">
            <Typography variant="prompt">HypurrFi net position</Typography>
            <Info>The dollar value of your deposits minus your borrows in HypurrFi.</Info>
          </span>
        </DrawerDescription>
        <DrawerTitle className="pb-4 pl-1" asChild>
          <Typography variant="h1" className="text-4xl lg:text-4xl">
            0<span className="text-muted-foreground">.00</span>
          </Typography>
        </DrawerTitle>
      </DrawerHeader>

      <div className="flex flex-col items-center justify-center gap-4">
        <div className="px-4 text-center">
          <Typography variant="p">Connect your wallet to see your HypurrFi overview.</Typography>
        </div>
        <ConnectButton source="side_drawer">Connect</ConnectButton>
      </div>
    </>
  )
}
